import {ObjectUtil} from "../../../js/util/ObjectUtil";

export enum TimeSeriesPeriod {
    DAILY = "DAILY",
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY",
    QUARTERLY = "QUARTERLY",
    YEARLY = "YEARLY"
}
export function timeSeriesPeriodName(period: TimeSeriesPeriod): string {
    switch (period) {
        case TimeSeriesPeriod.DAILY:
            return "D";
        case TimeSeriesPeriod.WEEKLY:
            return "W";
        case TimeSeriesPeriod.MONTHLY:
            return "M";
        case TimeSeriesPeriod.QUARTERLY:
            return "Q";
        case TimeSeriesPeriod.YEARLY:
            return "Y";
    }
}

export const TimeSeriesPeriods = ObjectUtil.keys(TimeSeriesPeriod)
                                           .map((k) => TimeSeriesPeriod[k]);

export function timePeriodDateFormat(period: TimeSeriesPeriod): string {
    switch (period) {
        case TimeSeriesPeriod.DAILY:
        case TimeSeriesPeriod.WEEKLY:

        case TimeSeriesPeriod.MONTHLY:
            return "MMM yyyy";
        case TimeSeriesPeriod.QUARTERLY:
            return "MMM yyyy";
        case TimeSeriesPeriod.YEARLY:
            return "yyyy";
    }
}
